import { ReactNode } from 'react';
import Navigation from '~/components/layouts/Navigation';

type DefaultLayoutProps = { children: ReactNode, className?: string };

export const DefaultLayout = ({ children, className }: DefaultLayoutProps) => {

  return (
    <main className={`text-foreground bg-background ${className}`}>
      <Navigation />
      <div className={'container w-full max-w-full h-screen pt-16'}>
          {children}
      </div>
    </main>
  );
};
